import { css } from "styled-components";
import { enhance } from "./enhance";

export const cssMixin = (styles, ...interpolations) => (defaultValues = {}) => {
  return css.apply(null, [styles, ...enhance(interpolations, defaultValues)]);
};